import { Link } from "react-router-dom";
const NavBar = () => {
	return (
		<>
			<div className="navbar bg-base-200">
				<div className="navbar-start">
					<div className="dropdown">
						<label tabIndex={0} className="btn btn-ghost me-5 lg:hidden">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-5 w-5"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="2"
									d="M4 6h16M4 12h8m-8 6h16"
								/>
							</svg>
						</label>
						<ul
							tabIndex={0}
							className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow  bg-base-200 rounded-box w-32"
						>
							<li>
								<Link className="btn-primary btn-outline" to="/">
									Home
								</Link>
							</li>
							<li>
								<Link className="btn-primary btn-outline" to="/about">
									About Me
								</Link>
							</li>
							<li>
								<Link className="btn-primary btn-outline" to="/projects">
									Projects
								</Link>
							</li>
							<li>
								<Link className="btn-primary btn-outline" to="/contact">
									Contact
								</Link>
							</li>
						</ul>
					</div>
					<Link to="/" className="text-info font-serif font-bold normal-case text-2xl mx-3">
						Portfolio
					</Link>
				</div>
				<div tabIndex={0} className="navbar-center hidden lg:flex">
					<ul className="menu menu-horizontal gap-4 px-1">
						<li>
							<Link className="btn-primary btn-outline" to="/">
								Home
							</Link>
						</li>
						<li>
							<Link className="btn-primary btn-outline" to="/about">
								About Me
							</Link>
						</li>
						<li>
							<Link className="btn-primary btn-outline" to="/projects">
								Projects
							</Link>
						</li>
						<li>
							<Link className="btn-primary btn-outline" to="/contact">
								Contact
							</Link>
						</li>
					</ul>

				</div>
				<div className="navbar-end ">
					{/* <div className="form-control">
						<input
							type="text"
							placeholder="Search"
							className="input input-sm  w-24 md:w-auto"
						/>
					</div> */}
				</div>
			</div>
		</>
	);
};
export default NavBar;
